// extracted by mini-css-extract-plugin
export default {"container":"GameFeatureIdeas_container__AE5RG"};